import { render } from "./HeroSemanticVersion.vue?vue&type=template&id=53e2c89f"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__